export default __webpack_public_path__ + "static/media/au_flashpay_fees_backgound.6a2d9eed.png";